module.exports = __webpack_public_path__ + "6ffa0ace1f662ff9679f423dcc2b1c2c.MP3";